import React from 'react'

import { Icon, RadioButtonChecked, RadioButtonUnchecked, classnames } from "@cgtrader/triangle-ui/dist/src/ssr-index"
import { bool, func, shape, string, oneOfType, number } from 'prop-types'

function SelectOptionItem({ option, isSelected = false, isFocused, searchable = false, onClick, onMouseEnter }) {
  return (
    <div
      role="option"
      tabIndex={-1}
      aria-selected={isSelected}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      className={classnames(
        'custom-searchable-select__option',
        isSelected && 'custom-searchable-select__option--selected',
        isFocused && 'custom-searchable-select__option--focused',
        !searchable && 'custom-searchable-select__option--default',
      )}
    >
      {searchable && (
        <Icon
          svgComponent={isSelected ? RadioButtonChecked : RadioButtonUnchecked}
          color={isSelected ? 'primary' : 'dark'}
          className="custom-searchable-select__option-icon"
        />
      )}
      <span className="custom-searchable-select__option-label">
        {option.label}
      </span>
    </div>
  )
}

SelectOptionItem.propTypes = {
  option: shape({
    label: string.isRequired,
    value: oneOfType([string, number]).isRequired,
  }).isRequired,
  isSelected: bool,
  isFocused: bool.isRequired,
  onClick: func.isRequired,
  onMouseEnter: func.isRequired,
  searchable: bool,
}

export default SelectOptionItem
